import { DashboardRouter } from "../dashboard.router";

export class SettingsRouter {
    
    static getRoute(): string {
        return `${DashboardRouter.getRoute()}/parameters`
    }

}